if (!customElements.get('video-responser')) {
  customElements.define('video-responser', class VideoResponser extends HTMLElement {
    constructor() {
      super();
      this.video= this.querySelector('video')
      // this.video.style.pointerEvents= 'none';
      // this.video.controls= false;

      this.options = {
        breakpoints: { "576": { src: this.video.getAttribute('src') } },
        posters: { "576": { poster: this.video.getAttribute('poster')} }
      };

      this.querySelectorAll('[data-src]').forEach(source => {
        this.options.breakpoints[source.getAttribute('data-mw')] = { src: source.getAttribute('data-src') }
        this.options.posters[source.getAttribute('data-mw')] = { poster: source.getAttribute('data-poster') }
      });

      this.observer= new IntersectionObserver(entries =>{
        entries.forEach(entry => {
          if(entry.isIntersecting){
            if(this.video.paused){
              this.video.play();
              this.playButton.setAttribute('playing', 'true')
            }
          }else{
            if(!this.video.paused){
              this.video.pause();
              if(this.playButton.hasAttribute('playing')) this.playButton.setAttribute('playing', 'false')
            }
          }
        })
      })

      this.soundButton= document.createElement('button');
      this.soundButton.id= "sound";
      this.soundButton.addEventListener('click', this.onSoundButtonClick.bind(this))
      // this.prepend(this.soundButton);

      this.playButton= document.createElement('button');
      this.playButton.id= "play";
      this.playButton.addEventListener('click', this.onPlayButtonClick.bind(this));
      // this.prepend(this.playButton);

      this.responseVideo(this.options)
      this.resizer();

      if(this.hasAttribute('auto-play')){
        this.video.muted= true;
        this.playButton.style.opacity= 0;
        this.playButton.setAttribute('playing', 'true')
        this.soundButton.setAttribute('muted','');
        this.observer.observe(this);
      }else{
        this.video.muted= false;
      }
    }
    resizer(){
      window.addEventListener("resize", ()=> this.responseVideo(this.options));
    }
    responseVideo(options) {
      const {breakpoints, posters} = options;
      const widthNow = this.getAttribute('data-width-now') || null;
      const choices = Object.keys(breakpoints).filter(key => key <= document.body.clientWidth )
      const minBreakpoint = Math.min.apply(Math, Object.keys(breakpoints).map(Number))
      let maxBreakpoint = minBreakpoint;
      if(choices.length>0) maxBreakpoint = Math.max.apply(Math, choices.map(Number));
      const nowBreakpoint = maxBreakpoint;
      if(widthNow == nowBreakpoint) return;
      this.setAttribute('data-width-now', nowBreakpoint);
      console.debug("Changing video")
      this.video.src = breakpoints[nowBreakpoint].src;
      this.video.poster = posters[nowBreakpoint].poster;
      this.video.play();
      this.playButton.setAttribute('playing', 'true')
    }
    onPlayButtonClick(e){
      if(this.playButton.hasAttribute('playing')){
        if(this.playButton.getAttribute('playing')=='true'){
          this.video.pause()
          this.playButton.setAttribute('playing', 'false')
          this.observer.disconnect()
        }else{
          this.video.play();
          if(this.hasAttribute('visible-play')) this.observer.observe(this);
        }
      }else{
        e.target.style.opacity= 0;
        this.video.play();
        if(this.hasAttribute('visible-play')) this.observer.observe(this);
      }
    }
    onSoundButtonClick(e){
      this.video.muted= !this.video.muted;
      e.target.hasAttribute("muted")?e.target.removeAttribute('muted'):e.target.setAttribute('muted','');
    }
  });
}